import { render, staticRenderFns } from "./modal-transferencia.vue?vue&type=template&id=3db98c37"
import script from "./modal-transferencia.vue?vue&type=script&lang=js"
export * from "./modal-transferencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports